import React, { useState } from "react";
import {
  useReactTable,
  getCoreRowModel,
  getSortedRowModel,
  getFilteredRowModel,
  flexRender,
} from "@tanstack/react-table";
import BackDrop from "../../ui/BackDrop";
import { closeIcon, deleteIconDark } from "../../../assetData/icons";
import DeleteAlert from "../../ui/DeleteAlert";

const DeleteTemplate = ({ data, buttonConfig, action }) => {
  const [selectedItem, setSelectedItem] = useState();
  const deleteHandler = buttonConfig.deleteHandler;
  const closeHandler = buttonConfig.closePopup;

  const onClose = () => {
    closeHandler(false);
  };

  const columns = React.useMemo(
    () => [
      {
        accessorKey: "sl",
        header: () => (
          <div className="flex w-[50px] justify-center ">S. NO.</div>
        ),
        cell: (info) => (
          <div className="flex w-[50px] justify-center">
            {info.row.index + 1}.
          </div>
        ),
      },
      {
        accessorKey: "template_id",
        header: () => <div className="w-[100px]">Template ID</div>,
        cell: (info) => (
          <div className="flex w-[100px] justify-start">{info.getValue()}</div>
        ),
      },
      {
        accessorKey: "action",
        header: () => <div className="w-[80px] text-center">Action</div>,
        cell: (info) => <div className="flex w-[80px] text-center justify-center"></div>,
      },
    ],
    [data],
  );

  const customTable = useReactTable({
    data: data,
    columns,
    getCoreRowModel: getCoreRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getSortedRowModel: getSortedRowModel(),
  });

  const handleDelete = async () => {
    const res = await deleteHandler(selectedItem?.data);
    setSelectedItem();
  };

  return (
    <>
      <div className="fixed left-1/2 top-[calc(12%)] z-50 mx-auto min-h-[300px] w-[98%] max-w-fit -translate-x-1/2 rounded bg-white p-8">
        {selectedItem?.type === "delete" && (
          <DeleteAlert
            deleteHandler={handleDelete}
            closeHandler={closeHandler}
          />
        )}
        <h2 className="pb-4 text-2xl font-bold text-neutral-800">
          Delete Template
        </h2>
        <button
          type="button"
          className="absolute right-8 top-8"
          onClick={onClose}
        >
          <img src={closeIcon} />
        </button>

        <div>
          <div className="scrollbar-custom mt-8 flex flex-col gap-2 max-xl:overflow-x-scroll ">
            <table className="w-full ">
              <thead className="block bg-pri-clr-blue">
                {customTable?.getHeaderGroups()?.map((headerGroup) => (
                  <tr key={headerGroup.id}>
                    {headerGroup.headers.map((header) => (
                      <th
                        key={header.id}
                        className="w-fit  border-[1px] border-black px-2 py-2 text-start  text-sm uppercase text-white"
                      >
                        {header.isPlaceholder
                          ? null
                          : flexRender(
                              header.column.columnDef.header,
                              header.getContext(),
                            )}
                      </th>
                    ))}
                  </tr>
                ))}
              </thead>
              <thead className="block h-2">
                <tr></tr>
              </thead>
              <tbody className="block  max-h-[300px] overflow-y-scroll border-[1px] border-neutral-clr-300 ">
                {customTable.getRowModel().rows.map((row) => (
                  <tr key={row.id}>
                    {row.getVisibleCells().map((cell, i) => (
                      <>
                        <td
                          key={cell.id}
                          className="w-fit whitespace-nowrap border-[1px] border-neutral-clr-300 px-2 py-1 text-sm text-black"
                        >
                          {flexRender(
                            cell.column.columnDef.cell,
                            cell.getContext(),
                          )}
                          {cell.id.split("_")[1] === "action" && (
                            <div className="flex justify-center">
                              <button
                                onClick={() =>
                                  setSelectedItem({
                                    data: {
                                      template_id:
                                        cell?.row?.original?.template_id,
                                    },
                                    type: "delete",
                                  })
                                }
                                disabled={!action?.delete_perm}
                              >
                                <img
                                  src={deleteIconDark}
                                  className={`${
                                    action?.delete_perm ? "" : "opacity-[55%]"
                                  }`}
                                  alt="i4invest"
                                />
                                <p></p>
                              </button>
                            </div>
                          )}
                        </td>
                      </>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <BackDrop closeHandler={onClose} />
    </>
  );
};

export default DeleteTemplate;
